import { FC, useEffect } from 'react'
import styles from './Form.module.scss'
import { Controller, useForm } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'
import { TInvestmentFormValues } from '../../types'
import { useNavigate } from 'react-router-dom';

type TInvestmentFormProps = {
    toggleResetAllForms: boolean
    setinvestmentFormData: React.Dispatch<React.SetStateAction<TInvestmentFormValues>>
    WEBSITE_FORM_DATA: TInvestmentFormValues
}
export const InvestmentForm: FC<TInvestmentFormProps> = ({ toggleResetAllForms, setinvestmentFormData, WEBSITE_FORM_DATA }) => {
    const { register, handleSubmit, control, reset, watch, setValue } = useForm<TInvestmentFormValues>({ defaultValues: WEBSITE_FORM_DATA })
    const { frequency } = watch()
    const onBlur = (data: TInvestmentFormValues) => {
        setinvestmentFormData(data)
    }
    let navigate = useNavigate();

    useEffect(() => {
        navigate('/')
        reset()
        setinvestmentFormData(WEBSITE_FORM_DATA)
    }, [toggleResetAllForms, reset, setinvestmentFormData, WEBSITE_FORM_DATA])

    return (
        <div>
            <h3 className={styles.formTitle}>Investment</h3>
            <form className={styles.form} onBlur={handleSubmit(onBlur)}>
                <div className={`${styles.formGroup} ${styles.amount}`}>
                    <label htmlFor="amount">Amount</label>
                    <Controller
                        name='amount'
                        control={control}
                        render={({ field: { onBlur, name, value } }) => (
                            <NumericFormat
                                thousandSeparator={true}
                                prefix='$'
                                onValueChange={(v) => {
                                    setValue("amount", Number(v.value))
                                }}
                                defaultValue={WEBSITE_FORM_DATA.amount}
                                name={name}
                                value={value}
                                onBlur={onBlur}
                            />
                        )}
                    />
                </div>
                <div className={styles.formGroup}>
                    <label htmlFor="frequency">Frequency</label>
                    <div className={styles.selectWrapper}>
                        <select id="frequency"
                            {...register("frequency")}
                        >
                            <option value='oneTime'> One-time</option>
                            <option value='monthly'> Monthly</option>
                        </select>
                    </div>
                </div>
                {frequency === 'monthly' ?
                    <div className={styles.formGroup}>
                        <div>
                            <label htmlFor="duration">Duration</label>
                            <div className={styles.selectWrapper}>
                                <select className={styles.months} id="duration" defaultValue={100}
                                    {...register("duration")}
                                >
                                    <option value={100}> Indefinitely</option>
                                    <option value={1}> 1 month</option>
                                    <option value={2}> 2 month</option>
                                    <option value={3}> 3 month</option>
                                    <option value={4}> 4 month</option>
                                    <option value={5}> 5 month</option>
                                    <option value={6}> 6 month</option>
                                    <option value={12}> 12 month</option>
                                    <option value={18}> 18 month</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    : null}
                <div className={styles.formGroup}>
                    <div>
                        <label htmlFor="duration">Delay before results</label>
                        <div className={styles.selectWrapper}>
                            <select id="delay" defaultValue={2}
                                {...register("delay")}
                            >
                                <option value={0}> No delay</option>
                                <option value={1}> 1 month</option>
                                <option value={2}> 2 month</option>
                                <option value={3}> 3 month</option>
                                <option value={4}> 4 month</option>
                                <option value={5}> 5 month</option>
                                <option value={6}> 6 month</option>
                                <option value={7}> 7 month</option>
                                <option value={8}> 8 month</option>
                                <option value={9}> 9 month</option>
                                <option value={10}> 10 month</option>
                                <option value={11}> 11 month</option>
                                <option value={12}> 12 month</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}
